export enum ContractorStatus {
  ACTIVE = 'active',
  BLOCKED = 'blocked',
}

export const ContractorStatusShown = {
  [ContractorStatus.ACTIVE]: 'Active',
  [ContractorStatus.BLOCKED]: 'Blocked',
};
